(function() {
    'use strict';

    angular.module('process')
        .controller('ProductionCubeListController', ProductionCubeListController);

    ProductionCubeListController.$inject = ['$state', 'productionCubeDataSrvc', 'checkSearchSrvc', 'processstagePermissionsConst', 'checkModelPermissionsSrvc', 'siteDataSrvc'];

    function ProductionCubeListController($state, productionCubeDataSrvc, checkSearchSrvc, processstagePermissionsConst, checkModelPermissionsSrvc, siteDataSrvc) {
        var self = this;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: null
        };
        self.pageChange = pageChange;

        self.productionCubeRows = [{
            title: null,
            value: 'machine_action_name',
            defaultValue: null
        }, {
            title: 'Liczba zleceń',
            value: 'products_count',
            defaultValue: '0'
        }, {
            title: null,
            value: 'realization_date',
            defaultValue: '-'
        }];
        self.productionCubeTitleRow = 'machine_name';
        self.productionCubeObjects = [];

        self.filterData = {
            order_pk: null,
            site_pk: null
        };

        self.modelPermissions = processstagePermissionsConst;
        self.onClick = onClick;
        self.onFilter = onFilter;

        self.siteOptions = [];
        self.isCanDisplaySites = false;
        self.initSiteOption = initSiteOption;

        activate();

        function activate() {
            self.isCanDisplaySites = canDisplaySites();
            getSiteOptions(getProductionCubes);
        }

        function getProductionCubes(filterObj) {
            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,

                    order_pk: self.filterData.order_pk,
                    site_pk: self.filterData.site_pk
                };
            }
            return productionCubeDataSrvc.list(filterObj)
                .$promise.then(
                    function(response) {
                        self.productionCubeObjects = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getProductionCubes);
                        }
                    }
                );
        }

        function pageChange() {
            getProductionCubes();
        }

        function onClick(object) {
            $state.go('layout.productionCube.details', { pk: object.pk });
        }

        function onFilter() {
            getProductionCubes();
        }

        function initSiteOption() {
            for (var index in self.siteOptions) {
                var optionPk = self.siteOptions[index].pk
                if (optionPk === config.siteId && self.filterData.site_pk === null){
                    self.filterData.site_pk = optionPk;
                }
            }
        }

        function getSiteOptions(callback) {
            if (self.isCanDisplaySites) {
                var siteIds = checkModelPermissionsSrvc.getPermittedSiteIds(
                    processstagePermissionsConst.view)
                return siteDataSrvc.getFieldOpts({"ids": siteIds}).$promise.then(
                    function(response) {
                        self.siteOptions = response.results;
                        initSiteOption();
                        callback();
                    });
            } else {
                callback();
            }
        }


        function canDisplaySites() {
            var ids = checkModelPermissionsSrvc.getPermittedSiteIds(processstagePermissionsConst.view)
            return ids.length > 1;
        }
    }
})();
